import React from 'react'

import Base from '../_Base'

const PlayFilled = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="m4 2 16 10L4 22z" fillRule="evenodd" />
  </Base>
)

export default PlayFilled
